import Vue from 'vue'
import App from './App.vue'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import { Plugin } from 'vue2-storage'
import ElementUI from 'element-ui'
import Router from 'vue-router'
import i18n from './lang' // Internationalization
import '@/styles/element-variables.scss'
import '@/styles/index.scss'
import '@/assets/iconfont/iconfont.css'
// import 'element-ui/lib/theme-chalk/index.css'
 
Vue.use(Router)
Vue.use(VueLodash, { lodash: lodash })
Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.use(Plugin, {
  prefix: 'app_',
  driver: 'local',
  ttl: 60 * 60 * 24 * 1000 * 100, // 24 hours
  replacer: (key, value) => value
})


const routes = [
  { path: '/', name: 'reader', component: () => import('@/components/Reader') }
]
if (!process.env.VUE_APP_ONLY_READER) {
  routes.push({ path: '/report', name: 'index', component: () => import('@/components/Index.vue') })
}

new Vue({
  render: h => h(App),
  i18n,
  router: new Router({ routes }),
}).$mount('#app')
